export default 'Contactez Solution Éco France pour cadrer votre dossier CEE, comparer vos offres énergie ou auditer votre conformité Décret Tertiaire.';
